<template>
  <form ref="form" @submit.prevent="onSubmit">
    <div class="row g-3">
      <div class="col-sm-6">
        <label class="form-label">{{ $t('email') }}</label>
        <multiselect
          v-model="empresaSelecionada"
          track-by="empresaId" label="email"
          :options="empresas"
          :placeholder="$t('selecionarReticencias')"
          :options-limit="10"
          :hide-selected="true"
          :select-label="$t('selecionar')"
          :selected-label="$t('selecionado')"
          :deselect-label="$t('remover')"
          :loading="isLoadingEmpresa"
          required
          @search-change="asyncFindEmail"
        >
          <template #noResult>
            <span>{{ $t('nenhumResultadoEncontrado') }}</span>
          </template>
        </multiselect>
      </div>
      <div class="col-sm-6">
        <label class="form-label">{{ $t('empresa') }}</label>
        <multiselect
          v-model="empresaSelecionada"
          track-by="empresaId" label="razaoSocial"
          :options="empresas"
          :placeholder="$t('selecionarReticencias')"
          :options-limit="10"
          :hide-selected="true"
          :select-label="$t('selecionar')"
          :selected-label="$t('selecionado')"
          :deselect-label="$t('remover')"
          :loading="isLoadingEmpresa"
          required
          @search-change="asyncFindEmpresas"
        >
          <template #noResult>
            <span>{{ $t('nenhumResultadoEncontrado') }}</span>
          </template>
        </multiselect>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-sm-6">
        <label class="form-label">{{ $t('tipoDaAssinatura') }}</label>
        <multiselect
          v-model="tipoAssinaturaSelecionado"
          track-by="productId" label="nome"
          :options="tiposAssinaturas"
          :placeholder="$t('selecionarReticencias')"
          :options-limit="10"
          :hide-selected="true"
          :select-label="$t('selecionar')"
          :selected-label="$t('selecionado')"
          :deselect-label="$t('remover')"
          :loading="isLoadingTipos"
          required
        >
          <template #noResult>
            <span>{{ $t('nenhumResultadoEncontrado') }}</span>
          </template>
        </multiselect>
      </div>
      <div class="col-sm-6">
        <label class="form-label">{{ $t('motivo') }}</label>
        <input v-model="motivo" type="text" class="form-control" required>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-sm-6">
        <label class="form-label">{{ $t('expiraEm') }}</label>
        <DateInput v-model="expiraEm" required />
      </div>
    </div>

    <hr>
    <div class="d-grid gap-2 d-md-flex justify-content-md-end">
      <router-link to="/admin/assinaturas" class="btn btn-secondary">
        <i class="bi bi-arrow-return-left" /> Voltar
      </router-link>
      <button class="btn btn-primary" @click="submit">
        <span class="bi bi-save">{{ $t("salvar") }}</span>
      </button>
    </div>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { getEmpresasIndicadores, getNomesAssinaturas } from '../assinaturasService';
import DateInput from '@/modules/core/components/DateInput.vue';
export default {
  components: { Multiselect, DateInput },
  emits: ['salvar-assinatura'],
  data: () => ({
    empresas: [],
    empresaSelecionada: null,
    isLoadingEmpresa: false,
    tiposAssinaturas: [],
    tipoAssinaturaSelecionado: null,
    isLoadingTipos: false,
    expiraEm: null,
    motivo: null,
  }),
  async beforeCreate() {
    this.isLoadingTipos = true;
    this.isLoadingEmpresa = true;
    getNomesAssinaturas().then((response) => {
      this.tiposAssinaturas = response;
      this.isLoadingTipos = false;
    });
    getEmpresasIndicadores().then((response) => {
      this.empresas = response;
      this.isLoadingEmpresa = false;
    });
  },
  mounted() {
    const expira = new Date();
    expira.setDate(expira.getDate() + 30);
    this.expiraEm = expira.toLocaleDateString('pt-BR');
  },
  methods: {

    asyncFindEmpresas(razaoSocial) {
      if (razaoSocial) {
        this.isLoadingEmpresa = true;
        getEmpresasIndicadores({ razaoSocial: razaoSocial }).then((response) => {
          this.empresas = response;
          this.isLoadingEmpresa = false;
        });
      }
    },
    asyncFindEmail(email) {
      if (email) {
        this.isLoadingEmpresa = true;
        getEmpresasIndicadores({ email: email }).then((response) => {
          this.empresas = response;
          this.isLoadingEmpresa = false;
        });
      }
    },
    submit() {
      this.$refs.form.checkValidity() && this.save();
    },
    save() {
      const data = this.expiraEm.split('/');
      const expiraEm = new Date(data[2], data[1] - 1, data[0]);
      expiraEm.setHours(23, 59, 59, 999);
      const assinatura = {
        productId: this.tipoAssinaturaSelecionado.productId,
        empresaId: this.empresaSelecionada.empresaId,
        expiraEm: expiraEm.getTime().toString(),
        motivo: this.motivo,
      };
      this.$emit('salvar-assinatura', assinatura);
      this.$router.push('/admin/assinaturas');
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" >
.multiselect .multiselect__tags {background: #1c1c1c;color:#fff;}
.multiselect__tags .multiselect__single {background: #1c1c1c;color:#fff;}
.multiselect .multiselect__input {background: #1c1c1c;color:#fff;}
.multiselect .multiselect__content-wrapper {background: #1c1c1c;color:#fff;font-size: 0.9rem;}
.multiselect .multiselect__option--highlight::after{content:attr(data-select);background:#e75e0f;color:#fff}
.multiselect .multiselect__option--highlight {background-color: #e75e0f;font-size: 0.9rem;height: 1rem;}
.multiselect .multiselect__spinner{background:#1c1c1c}
.multiselect .multiselect__spinner::before{border-color:#e75e0f transparent transparent}
.multiselect .multiselect__spinner::after{border-color:#e75e0f transparent transparent}
</style>
